@let langSignalValue = languageService.langSignal();
@let isContactEditing = showContactEditInfo();
@let isRegionEditing = showRegionEditInfo();

<mat-card appearance="outlined" class="useradmin-contract-main-card">
  <div class="useradmin-overview-glass-card">
    <!-- Haupt-Header mit Kundennummer (Kompakter) -->
    <div class="overview-header-zone">
      <div class="overview-icon-box">
        <fa-icon [icon]="['far', 'id-badge']" size="lg"></fa-icon>
      </div>
      <div class="overview-title-text">
        <span class="overview-label">
          {{ 'PRODUCT.USERADMIN.CUSTOMERID' | translate }}
        </span>
        <h3 class="overview-id-highlight">
          {{ userService.customerDocument()?.customerId }}
        </h3>
      </div>
    </div>

    <!-- Rechter Bereich / Unterer Bereich: Die Vertragslaufzeiten direkt integriert -->
    <div class="overview-dates-zone">
      <div class="overview-info-grid">
        <!-- Startdatum -->
        <div class="overview-info-item">
          <span class="info-label">
            <fa-icon
              [icon]="['far', 'arrow-from-left']"
              class="u-icon-gap-small"></fa-icon>
            {{ 'PRODUCT.USERADMIN.START' | translate }}
          </span>
          <span class="info-value">
            {{
              contractStartDtg()
                | datex: 'DD.MM.YYYY' : undefined : langSignalValue
            }}
          </span>
        </div>

        <!-- Enddatum -->
        <div class="overview-info-item">
          <span class="info-label">
            <fa-icon
              [icon]="['far', 'arrow-to-right']"
              class="u-icon-gap-small"></fa-icon>
            {{ 'PRODUCT.USERADMIN.END' | translate }}
          </span>
          <span class="info-value">
            @let contractExpiryDtgValue = contractExpiryDtg();
            @if (contractExpiryDtgValue | isNil) {
              <span class="status-badge status-positive">
                {{ 'PRODUCT.USERADMIN.ENDLESS' | translate }}
              </span>
            } @else {
              {{
                contractExpiryDtgValue
                  | datex: 'DD.MM.YYYY' : undefined : langSignalValue
              }}
            }
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Sektion: Kontingente (Echtzeitverbrauch) -->
  @let contingentsValue = contingents();
  @if (contingentsValue | isNotEmptyObject) {
    <mat-accordion class="licence-main-accordion contingent-management-card">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="panel-title-flex">
            <fa-icon
              [icon]="['far', 'file-certificate']"
              class="region-header-icon"></fa-icon>
            <strong>{{
              'PRODUCT.USERADMIN.CONTRACT.LICENSEINFO' | translate
            }}</strong>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-card-header class="contingent-card-header">
          <div class="contingent-header-icon-box">
            <fa-icon [icon]="['far', 'chart-pie']" size="lg"></fa-icon>
          </div>
          <div class="contingent-header-text">
            <mat-card-title class="contingent-title">
              {{ 'PRODUCT.USERADMIN.CONTINGENT.CONTINGENTS' | translate }}
            </mat-card-title>
            <mat-card-subtitle class="contingent-subtitle text-muted">
              {{ 'PRODUCT.USERADMIN.CONTINGENT.CONTINGENTTEXT' | translate }}
            </mat-card-subtitle>
          </div>
        </mat-card-header>

        <mat-card-content class="contingent-card-content">
          <div class="contingent-table-wrapper">
            <table class="contingent-native-table">
              <thead>
                <tr>
                  <th class="text-left">
                    {{ 'PRODUCT.USERADMIN.CONTINGENT.CONTINGENTS' | translate }}
                  </th>
                  <th class="text-center">
                    {{ 'PRODUCT.USERADMIN.CONTINGENT.PAID' | translate }}
                  </th>
                  <th class="text-center">
                    {{ 'PRODUCT.USERADMIN.CONTINGENT.USED' | translate }}
                  </th>
                  <th class="text-center">
                    {{ 'PRODUCT.USERADMIN.CONTINGENT.AVAILABLE' | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (
                  contingentType of ['online', 'app', 'sms', 'fax'];
                  track contingentType
                ) {
                  @let availableValue =
                    contingentsValue[contingentType] -
                    userService.usedContingents()[contingentType];
                  <tr class="contingent-row">
                    <td class="text-left type-cell">
                      <span
                        class="type-indicator-dot"
                        [attr.data-type]="contingentType"></span>
                      {{
                        'PRODUCT.USERADMIN.CONTINGENT.' + contingentType
                          | translate
                      }}
                    </td>
                    <td class="text-center value-cell-muted">
                      {{ contingentsValue[contingentType] }}
                    </td>
                    <td class="text-center value-cell-muted">
                      {{ userService.usedContingents()[contingentType] }}
                    </td>
                    <td class="text-center status-cell">
                      <span
                        class="status-badge"
                        [ngClass]="
                          availableValue < 0
                            ? 'status-negative'
                            : 'status-positive'
                        ">
                        {{ availableValue }}
                      </span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </mat-card-content>
      </mat-expansion-panel>
    </mat-accordion>
  }

  <!-- Sektion: Kontaktinformationen (Anzeige / Editieren) -->
  <div class="useradmin-form-spacing-box">
    @let contactFormGroup = userService.contactInfoFormGroup;

    <form [formGroup]="contactFormGroup" (ngSubmit)="onSaveContactInfo()">
      <mat-accordion multi class="contact-main-accordion">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="panel-title-flex">
              <fa-icon
                [icon]="['far', 'address-book']"
                class="region-header-icon"></fa-icon>
              <strong>{{
                'PRODUCT.USERADMIN.CONTRACT.CONTACTSINFO' | translate
              }}</strong>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <!-- ZWEI-SPALTEN LAYOUT CONTAINER -->
          <div class="columns-split-container">
            <!-- LINKE SPALTE: Ansprechpartner -->
            <div class="form-column-half">
              <!-- Aufgewerteter Header mit Icon-Box -->
              <div class="form-section-header">
                <div class="form-header-icon-box">
                  <fa-icon [icon]="['far', 'users']" size="lg"></fa-icon>
                </div>
                <div class="form-header-text">
                  <h3 class="section-title">
                    {{ 'PRODUCT.USERADMIN.CONTRACT.MAINCONTACT' | translate }}
                  </h3>
                  <p class="text-description-muted">
                    {{ 'PRODUCT.USERADMIN.CONTRACT.CONTACTINFO' | translate }}
                  </p>
                </div>
              </div>

              <div formArrayName="contacts" class="dynamic-contacts-container">
                <label class="form-question-label">{{
                  'PRODUCT.USERADMIN.CONTRACT.MAINCONTACT' | translate
                }}</label>
                <!-- FIX: Sicherer Tracker gegen NG0956 (mit Fallback auf $index falls id null ist) -->
                @for (
                  row of contactRows.controls;
                  track row.get('id')?.value || $index;
                  let i = $index
                ) {
                  <div
                    [formGroupName]="i"
                    class="contact-row-layout"
                    [class.is-row-readonly]="!isContactEditing">
                    <!-- Feld 1: Name -->
                    <mat-form-field appearance="fill" class="flex-field">
                      <mat-label>{{
                        'PRODUCT.USERADMIN.CONTRACT.CONTACT.NAME' | translate
                      }}</mat-label>
                      <input
                        matInput
                        formControlName="name"
                        [readonly]="!isContactEditing"
                        placeholder="Max Mustermann" />
                    </mat-form-field>

                    <!-- Feld 2: E-Mail -->
                    <mat-form-field appearance="fill" class="flex-field">
                      <mat-label>{{
                        'PRODUCT.USERADMIN.CONTRACT.CONTACT.EMAIL' | translate
                      }}</mat-label>
                      <input
                        matInput
                        type="email"
                        formControlName="email"
                        [readonly]="!isContactEditing"
                        placeholder="max@firma.de" />
                    </mat-form-field>

                    <!-- Feld 3: Telefon -->
                    <mat-form-field appearance="fill" class="flex-field">
                      <mat-label>{{
                        'PRODUCT.USERADMIN.CONTRACT.CONTACT.PHONE' | translate
                      }}</mat-label>
                      <input
                        matInput
                        type="tel"
                        formControlName="phone"
                        [readonly]="!isContactEditing"
                        placeholder="+49 123 456" />
                    </mat-form-field>

                    <!-- Löschen Button -->
                    @if (isContactEditing) {
                      <button
                        mat-icon-button
                        color="warn"
                        type="button"
                        class="row-action-btn"
                        (click)="removeContactRow(i)">
                        <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                      </button>
                    }
                  </div>
                }
              </div>

              @if (isContactEditing) {
                <div class="add-row-zone">
                  <button
                    mat-stroked-button
                    type="button"
                    class="btn-add-contact"
                    (click)="addContactRow()">
                    <fa-icon
                      [icon]="['far', 'plus']"
                      class="u-icon-gap"></fa-icon>
                  </button>
                </div>
              }

              @if (customerContact() === '' && !isContactEditing) {
                <div class="explanation-box-fallback">
                  [{{ 'PRODUCT.USERADMIN.NOCONTACT' | translate }}]
                </div>
              }
            </div>

            <!-- RECHTE SPALTE: Rechnungslegung -->
            <div class="form-column-half billing-section-zone">
              <!-- Aufgewerteter Header mit Icon-Box -->
              <div class="form-section-header">
                <div class="form-header-icon-box billing-icon-style">
                  <fa-icon
                    [icon]="['far', 'file-invoice-dollar']"
                    size="lg"></fa-icon>
                </div>
                <div class="form-header-text">
                  <h3 class="section-title">
                    {{
                      'PRODUCT.USERADMIN.CONTRACT.FINANCIALREPORTING'
                        | translate
                    }}
                  </h3>
                  <p class="text-description-muted">
                    {{
                      'PRODUCT.USERADMIN.CONTRACT.FINANCIALREPORTING_DESC'
                        | translate
                    }}
                  </p>
                </div>
              </div>

              <div class="billing-fields-container">
                <!-- 1. Firmenname -->
                <div class="form-question-block">
                  <label class="form-question-label"
                    >{{
                      'PRODUCT.USERADMIN.CONTRACT.FINANCIALREPORTING_COMPANYNAME'
                        | translate
                    }}:</label
                  >
                  <mat-form-field
                    appearance="fill"
                    class="full-width-field"
                    [class.is-readonly]="!isContactEditing">
                    <input
                      matInput
                      formControlName="billingCompanyName"
                      [readonly]="!isContactEditing"
                      placeholder="ABC GmbH" />
                  </mat-form-field>
                </div>

                <!-- 2. Straße / Hausnummer -->
                <div class="form-question-block">
                  <label class="form-question-label"
                    >{{
                      'PRODUCT.USERADMIN.CONTRACT.FINANCIALREPORTING_STREET'
                        | translate
                    }}:</label
                  >
                  <mat-form-field
                    appearance="fill"
                    class="full-width-field"
                    [class.is-readonly]="!isContactEditing">
                    <input
                      matInput
                      formControlName="billingStreet"
                      [readonly]="!isContactEditing"
                      placeholder="ABC Street 12" />
                  </mat-form-field>
                </div>

                <div class="form-question-block">
                  <label class="form-question-label"
                    >{{
                      'PRODUCT.USERADMIN.CONTRACT.FINANCIALREPORTING_POSTAL'
                        | translate
                    }}:</label
                  >
                  <div class="billing-zip-city-row">
                    <mat-form-field
                      appearance="fill"
                      class="zip-field"
                      [class.is-readonly]="!isContactEditing">
                      <mat-label>{{
                        'PRODUCT.USERADMIN.CONTRACT.FINANCIALREPORTING_POSTALCODE'
                          | translate
                      }}</mat-label>
                      <input
                        matInput
                        formControlName="billingZip"
                        [readonly]="!isContactEditing"
                        placeholder="12345" />
                    </mat-form-field>

                    <mat-form-field
                      appearance="fill"
                      class="city-field"
                      [class.is-readonly]="!isContactEditing">
                      <mat-label>{{
                        'PRODUCT.USERADMIN.CONTRACT.FINANCIALREPORTING_CITY'
                          | translate
                      }}</mat-label>
                      <input
                        matInput
                        formControlName="billingCity"
                        [readonly]="!isContactEditing"
                        placeholder="{{
                          'PRODUCT.USERADMIN.CONTRACT.FINANCIALREPORTING_CITY'
                            | translate
                        }}" />
                    </mat-form-field>
                  </div>
                </div>

                <!-- 4. E-Mail -->
                <div class="form-question-block">
                  <label class="form-question-label">E-Mail:</label>
                  <mat-form-field
                    appearance="fill"
                    class="full-width-field"
                    [class.is-readonly]="!isContactEditing">
                    <input
                      matInput
                      type="email"
                      formControlName="billingEmail"
                      [readonly]="!isContactEditing"
                      placeholder="billing@company.de" />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <!-- Aktionsknöpfe -->
          <mat-card-actions class="sub-card-actions-padding flex-actions-end">
            @if (!isContactEditing) {
              <button
                mat-flat-button
                class="btn-app-edit"
                type="button"
                (click)="onShowContactEdit(true)">
                <fa-icon [icon]="['far', 'edit']" class="u-icon-gap"></fa-icon>
                {{ 'PRODUCT.USERADMIN.EDIT' | translate }}
              </button>
            } @else {
              <button
                mat-flat-button
                class="btn-app-cancel"
                type="button"
                (click)="onShowContactEdit(false)">
                {{ 'PRODUCT.USERADMIN.CANCEL' | translate }}
              </button>
              <button mat-flat-button class="btn-app-save" type="submit">
                <fa-icon [icon]="['far', 'check']" class="u-icon-gap"></fa-icon>
                {{ 'PRODUCT.USERADMIN.SAVE' | translate }}
              </button>
            }
          </mat-card-actions>
        </mat-expansion-panel>
      </mat-accordion>
    </form>
  </div>

  <div class="useradmin-form-spacing-box">
    @let regionFormGroup = userService.regionFormGroup;
    <form [formGroup]="regionFormGroup" (ngSubmit)="onSaveRegionInfo()">
      <mat-accordion multi class="region-main-accordion">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="panel-title-flex">
              <fa-icon
                [icon]="['far', 'map-marked-alt']"
                class="region-header-icon"></fa-icon>
              <strong>{{
                'PRODUCT.USERADMIN.CONTRACT.REGIONINFO' | translate
              }}</strong>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div
            [formGroup]="regionFormGroup"
            class="columns-split-container row-optimized-layout">
            <!-- LINKE SPALTE: Textbereiche -->
            <div class="form-column-half">
              <!-- 1. Einsatzort / Einsatzorte -->
              <div class="form-question-block">
                <label class="form-question-label">
                  {{
                    'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_WORKPLACES'
                      | translate
                  }}:
                </label>
                @if (isRegionEditing) {
                  <p class="text-description-muted field-hint">
                    {{
                      'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_WORKPLACES_DESC'
                        | translate
                    }}
                  </p>
                }
                <mat-form-field
                  appearance="fill"
                  class="full-width-field"
                  [class.is-readonly]="!isRegionEditing">
                  <textarea
                    formControlName="locations"
                    rows="3"
                    matInput
                    [readonly]="!isRegionEditing"
                    placeholder="Stationen oder Regionen eintragen..."></textarea>
                </mat-form-field>
              </div>

              <!-- 2. Lokale Besonderheiten -->
              <div class="form-question-block">
                <label class="form-question-label">
                  {{
                    'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_OPERATIONWINTER'
                      | translate
                  }}:
                </label>
                <mat-form-field
                  appearance="fill"
                  class="full-width-field"
                  [class.is-readonly]="!isRegionEditing">
                  <textarea
                    formControlName="localFeatures"
                    rows="2"
                    matInput
                    [readonly]="!isRegionEditing"
                    placeholder="{{
                      'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_OPERATIONWINTER'
                        | translate
                    }}"></textarea>
                </mat-form-field>
              </div>
            </div>

            <!-- RECHTE SPALTE: Strukturierte Daten (Höhe, Brücken) -->
            <div class="form-column-half side-padding-border">
              <!-- 3. Höhenlage Ihres Einsatzgebiets -->
              <div class="form-question-block">
                <label class="form-question-label"
                  >{{
                    'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_ALTITUDE'
                      | translate
                  }}:</label
                >
                <div
                  class="elevation-inputs-row"
                  [class.is-readonly]="!isRegionEditing">
                  <mat-form-field appearance="fill">
                    <mat-label>{{
                      'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_LOWEST_ELEVATION'
                        | translate
                    }}</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="elevationMin"
                      [readonly]="!isRegionEditing" />
                  </mat-form-field>
                  <mat-form-field appearance="fill">
                    <mat-label>{{
                      'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_HIGHEST_ELEVATION'
                        | translate
                    }}</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="elevationMax"
                      [readonly]="!isRegionEditing" />
                  </mat-form-field>
                </div>
              </div>

              <!-- 4. Brücken im Einsatzgebiet -->
              <div class="form-question-block">
                <label class="form-question-label"
                  >{{
                    'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_BRIDGES' | translate
                  }}:</label
                >
                <div
                  class="radio-group-wrapper"
                  [class.is-readonly]="!isRegionEditing">
                  <mat-radio-group formControlName="bridges" color="primary">
                    <mat-radio-button
                      value="viele"
                      [disabled]="!isRegionEditing"
                      >{{ 'PRODUCT.COMMON.MANY' | translate }}</mat-radio-button
                    >
                    <mat-radio-button
                      value="wenige"
                      [disabled]="!isRegionEditing"
                      >{{ 'PRODUCT.COMMON.FEW' | translate }}</mat-radio-button
                    >
                    <mat-radio-button
                      value="keine"
                      [disabled]="!isRegionEditing"
                      >{{
                        'PRODUCT.COMMON.NONEATALL' | translate
                      }}</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div [formGroup]="regionFormGroup" class="gma-section-container">
        <div class="form-question-block has-gma-main-toggle">
          <label class="form-question-label main-gma-label">
            {{ 'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_GMA' | translate }}
          </label>

          <!-- Die Klasse .is-readonly steuert die adaptive Optik im schreibgeschützten Modus -->
          <div
            class="radio-group-wrapper"
            [class.is-readonly]="!showRegionEditInfo()">
            <mat-radio-group formControlName="hasGma" color="primary">
              <mat-radio-button value="ja" [disabled]="!showRegionEditInfo()">
                {{ 'PRODUCT.COMMON.YES' | translate }}
              </mat-radio-button>
              <mat-radio-button value="nein" [disabled]="!showRegionEditInfo()">
                {{ 'PRODUCT.COMMON.NO' | translate }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        @if (regionFormGroup.get('hasGma')?.value === 'ja') {
          <div
            class="gma-accordion-wrapper animate-fade-in"
            formArrayName="gmaList">
            <mat-accordion multi class="gma-custom-accordion">
              @for (
                row of gmaRows.controls;
                track row.get('id')?.value;
                let idx = $index
              ) {
                <mat-expansion-panel
                  [formGroupName]="idx"
                  [expanded]="idx === 0">
                  <!-- Akkordeon Header -->
                  <mat-expansion-panel-header>
                    <mat-panel-title class="gma-panel-title">
                      <fa-icon
                        [icon]="['far', 'broadcast-tower']"
                        class="gma-header-icon"></fa-icon>
                      <strong
                        >{{
                          'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_GMA_TITLE'
                            | translate
                        }}
                        #{{ idx + 1 }}
                      </strong>
                      <span class="gma-title-summary">
                        {{
                          row.get('gmaManufacturer')?.value ||
                            '(Kein Hersteller eingetragen)'
                        }}
                      </span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <div class="gma-panel-inner-layout">
                    <div class="form-question-block">
                      <label class="form-question-label"
                        >{{
                          'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_GMA_COORDINATES'
                            | translate
                        }}:</label
                      >
                      <p class="text-description-muted field-hint">
                        {{
                          'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_GMA_COORDINATES_HINT'
                            | translate
                        }}
                      </p>
                      <mat-form-field
                        appearance="fill"
                        class="full-width-field"
                        [class.is-readonly]="!showRegionEditInfo()">
                        <textarea
                          formControlName="gmaCoordinates"
                          rows="2"
                          matInput
                          [readonly]="!showRegionEditInfo()"
                          placeholder="Koordinaten, Höhe oder Google Maps Link eintragen..."></textarea>

                        @if (!showRegionEditInfo() && isMapsLinkInRow(row)) {
                          <a
                            matSuffix
                            [href]="getSafeMapsLinkInRow(row)"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="maps-preview-suffix-link">
                            <fa-icon
                              [icon]="['far', 'external-link']"></fa-icon>
                          </a>
                        }
                      </mat-form-field>

                      @if (showRegionEditInfo() && isMapsLinkInRow(row)) {
                        <div class="maps-detected-badge animate-fade-in">
                          <fa-icon
                            [icon]="['far', 'map-marker-alt']"
                            class="badge-icon"></fa-icon>
                          <span>{{
                            'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_GOOGLEMAPS'
                              | translate
                          }}</span>
                        </div>
                      }
                    </div>

                    <div class="form-question-block">
                      <label class="form-question-label"
                        >{{
                          'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_GMA_MANUFACTURER'
                            | translate
                        }}:</label
                      >

                      <mat-form-field
                        appearance="fill"
                        class="full-width-field"
                        [class.is-readonly]="!showRegionEditInfo()">
                        <mat-label>{{
                          'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_GMA_MANUFACTURERTYPE'
                            | translate
                        }}</mat-label>
                        <mat-select
                          formControlName="gmaManufacturer"
                          placeholder="Bitte wählen...">
                          @for (
                            group of gmaManufacturerOptions;
                            track group.manufacturer
                          ) {
                            <mat-optgroup [label]="group.manufacturer">
                              @for (model of group.models; track model) {
                                <mat-option
                                  [value]="
                                    group.manufacturer + '; Modell: ' + model
                                  ">
                                  {{ model }}
                                </mat-option>
                              }
                            </mat-optgroup>
                          }

                          <mat-optgroup
                            label="{{
                              'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_GMA_MANUFACTURER_NOTYPE'
                                | translate
                            }}">
                            <mat-option value="Hersteller: ; Modell: ">{{
                              'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_GMA_MANUFACTURER_NOTYPE'
                                | translate
                            }}</mat-option>
                          </mat-optgroup>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    @if (
                      row.get('gmaManufacturer')?.value ===
                      campbellWinterSenseSolar
                    ) {
                      <div class="form-question-block animate-fade-in">
                        <label class="form-question-label"
                          >{{
                            'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_GMA_PRODUCTKEY'
                              | translate
                          }}
                          *:</label
                        >

                        <mat-form-field
                          appearance="fill"
                          class="full-width-field"
                          [class.is-readonly]="!showRegionEditInfo()">
                          <mat-label>{{
                            'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_GMA_PRODUCTKEY'
                              | translate
                          }}</mat-label>
                          <input
                            matInput
                            [readonly]="!showRegionEditInfo()"
                            formControlName="gmaProductKey"
                            placeholder="####-####-####" />

                          @if (
                            row.get('gmaProductKey')?.hasError('required') ||
                            row
                              .get('gmaProductKey')
                              ?.hasError('gmaProductKeyRequired')
                          ) {
                            <mat-error>
                              {{
                                'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_GMA_PRODUCTKEY_MANDATORY'
                                  | translate
                              }}
                            </mat-error>
                          }

                          @if (
                            row.get('gmaProductKey')?.hasError('pattern') ||
                            row
                              .get('gmaProductKey')
                              ?.hasError('gmaProductKeyPattern')
                          ) {
                            <mat-error>
                              {{
                                'PRODUCT.USERADMIN.CONTRACT.GMA_CAMPBELL_PLACEHOLDER'
                                  | translate
                              }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    }

                    <!-- 3. Webcam Vorhanden -->
                    <div class="form-question-block">
                      <label class="form-question-label">{{
                        'PRODUCT.USERADMIN.CONTRACT.REGIONINFO_GMA_WEBCAM'
                          | translate
                      }}</label>
                      <div class="radio-group-wrapper">
                        <mat-radio-group
                          formControlName="gmaWebcam"
                          color="primary">
                          <mat-radio-button value="vorhanden">{{
                            'PRODUCT.COMMON.WEBCAM' | translate
                          }}</mat-radio-button>
                          <mat-radio-button value="keine">{{
                            'PRODUCT.COMMON.NOWEBCAM' | translate
                          }}</mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>

                    @if (showRegionEditInfo()) {
                      <div class="gma-row-actions">
                        <button
                          mat-stroked-button
                          color="warn"
                          type="button"
                          (click)="removeGmaRow(idx)">
                          <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                          {{ 'PRODUCT.COMMON.REMOVEGMA' | translate }}
                        </button>
                      </div>
                    }
                  </div>
                </mat-expansion-panel>
              }
            </mat-accordion>

            <!-- Hinzufügen Button unter dem Akkordeon -->
            @if (showRegionEditInfo()) {
              <div class="add-gma-btn-zone">
                <button
                  mat-flat-button
                  color="primary"
                  type="button"
                  (click)="addGmaRow()">
                  <fa-icon [icon]="['far', 'plus']"></fa-icon>
                  {{ 'PRODUCT.COMMON.ADDGMA' | translate }}
                </button>
              </div>
            }
          </div>
        }
      </div>
    </form>
  </div>
  <div class="sticky-action-bar" [class.is-editing]="showRegionEditInfo()">
    @if (!showRegionEditInfo()) {
      <button
        mat-flat-button
        class="btn-app-edit"
        type="button"
        (click)="onEditRegion()">
        <fa-icon [icon]="['far', 'edit']"></fa-icon> &nbsp;
        {{ 'PRODUCT.USERADMIN.EDIT' | translate }}
      </button>
    } @else {
      <button
        mat-flat-button
        class="btn-app-cancel"
        type="button"
        (click)="onShowRegionEdit(false)">
        {{ 'PRODUCT.USERADMIN.CANCEL' | translate }}
      </button>
      <button
        mat-flat-button
        class="btn-app-save"
        type="submit"
        (click)="onSaveRegionInfo()"
        [disabled]="userService.regionFormGroup.invalid">
        <fa-icon [icon]="['far', 'check']"></fa-icon> &nbsp;
        {{ 'PRODUCT.USERADMIN.SAVE' | translate }}
      </button>
    }
  </div>
</mat-card>
